import React, { FC, useEffect, useState } from 'react';
import './organisation-toast.scss';

const VISIBLE_MS = 4000;
const EXIT_MS = 220;

interface OrganisationToastProps {
  message: string;
  onDismiss: () => void;
}

/**
 * Transient confirmation for Members actions: slides in top-right on desktop
 * and bottom-centre on mobile, then slides back out before unmounting.
 */
const OrganisationToast: FC<OrganisationToastProps> = ({
  message,
  onDismiss,
}) => {
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const hide = setTimeout(() => setLeaving(true), VISIBLE_MS);
    const unmount = setTimeout(onDismiss, VISIBLE_MS + EXIT_MS);
    return () => {
      clearTimeout(hide);
      clearTimeout(unmount);
    };
  }, [onDismiss]);

  return (
    <div
      className={`organisation-toast${leaving ? ' leaving' : ''}`}
      role='status'
      data-testid='organisation-toast'
    >
      {message}
    </div>
  );
};

export default OrganisationToast;
